import script from "./BroadCast.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadCast.vue?vue&type=script&setup=true&lang=js"

import "./BroadCast.vue?vue&type=style&index=0&id=f977b7e6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f977b7e6"]])

export default __exports__